(function ($) {
    var slideSingle = $('body .img-grid-slider .slider-wrapper .slide-box .img-slide').length;

    $('.img-grid-slider .slider-wrapper .slide-box').slick({
        centerMode: true,
        centerPadding: '12%',
        slidesToShow: 1,
        infinite: true,
        dots: true,
        dotsClass: 'custom-dots',
        arrows: false,
        speed: 700,
        autoplay: true,
        autoplaySpeed: 4000,
        cssEase: 'ease',
        focusOnSelect: true,
        pauseOnHover: false,
        asNavFor: '.text-box-wrapper',
        responsive: [
            {
                breakpoint: 991,
                settings: {
                    centerPadding: '12%',
                }
            },
            {
                breakpoint: 480,
                settings: {

                    centerMode: false,
                    centerPadding: '0',
                }
            }
        ]
});
    $('.text-box-wrapper').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        asNavFor: '.slide-box',
        dots: false,
        arrow: false,
        fade: true,
        autoplay: true,
        autoplaySpeed: 4000,
        pauseOnHover: false,
        focusOnSelect: true,
        adaptiveHeight: true
    });

    $(document).ready(function () {
        var height = $('body .img-grid-slider .slider-wrapper .img-slide').matchHeight();
    });
    if (slideSingle <= 1) {
        $('body .img-grid-slider .slider-wrapper .slide-box .custom-dots li').hide();
    } else {
        $('body .img-grid-slider .slider-wrapper .slide-box .custom-dots li').show();
    }

    $(window).resize(function () {
        var slideSingle = $('body .img-grid-slider .slider-wrapper .slide-box .img-slide').length;
        if (slideSingle <= 1) {
            $('body .img-grid-slider .slider-wrapper .slide-box .custom-dots li').hide();
        } else {
            $('body .img-grid-slider .slider-wrapper .slide-box .custom-dots li').show();
        }
    });

})(jQuery);